const INITIAL_ANIMATION_SESSION_VAL = 'initialAnimationPlayed';

export function getInitialAnimationedPlayed() {
    return sessionStorage.getItem(INITIAL_ANIMATION_SESSION_VAL);
}

export function setInitialAnimationPlayed() {
    return sessionStorage.setItem(INITIAL_ANIMATION_SESSION_VAL, 1);
}
